module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/humidity-f6f97c5f6b692e20bbb132d27e5fa8e1.svg";